import React, { Component } from 'react';
import { Tabs, Tab, Button, ButtonToolbar, Col } from 'react-bootstrap';
import Toggle from 'react-toggle'

import { PropTypes } from 'prop-types';
import { MapPointsActive } from './MapPointsActive';
import { MapPointActiveForm } from './MapPointActiveForm';
import { MapPointsDraft } from './MapPointsDraft';
import { MapPointDraftForm } from './MapPointDraftForm';
import { HandleMessage } from '../../../HandleMessage';
import { HandleDialog } from '../../../HandleDialog';
import { MapPointsCommand } from '../../commands/MapPointsCommand';
import { MapPointsDraftCommand } from '../../commands/MapPointsDraftCommand';
import { StopsCommand } from '../../commands/StopsCommand';
import { StopsDraftCommand } from '../../commands/StopsDraftCommand';
import { InterfacesCommand } from '../../../files/commands/InterfacesCommand';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { PaginationHelper } from '../../../helpers/PaginationHelper';
import { SearchBar } from '../../../SearchBar';
import { TitleRow } from '../../../TitleRow';
import { EditionSelector } from '../../../EditionSelector';

export class ProviderMapPoints extends Component {
    static contextTypes = {
        selectedProvider: PropTypes.string,
        edition: PropTypes.object,
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            data: {
                active: {
                    mapPoints: [],
                },
                draft: {
                    mapPoints: [],
                }
            },
            dependencies: {
                interfaces: [],
                activeStops: [],
                draftStops: [],
            },
            form: {
                active: {
                    mapPoint: undefined
                },
                draft: {
                    mapPoint: undefined
                }
            },
            render: {
                tab: "active",
                compare: false,
                filter: ""
            },
            pagination: {
                active: {
                    page: 1,
                    elementsPerPage: 50
                },
                draft: {
                    page: 1,
                    elementsPerPage: 50
                }
            },
            actions: {
                active: {
                    isLoading: true,
                    isUpdating: false,
                    isDeleting: false,
                },
                draft: {
                    isLoading: true,
                    isUpdating: false,
                    isDeleting: false,
                },
                isLoadingInterfaces: true,
                isLoadingDraftStops: true,
                isLoadingActiveStops: false,
            },
            commands: {
                active: {
                    mapPoints: new MapPointsCommand(),
                    stops: new StopsCommand(),
                },
                draft: {
                    mapPoints: new MapPointsDraftCommand(),
                    stops: new StopsDraftCommand(),
                },
                interfaces: new InterfacesCommand()
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        }
    }

    componentDidMount() {
        this.context.addEditionObserver(this);

        // Not associated with any type of Edition
        this.getInterfaces();
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // ----------------------

    startUpdate() {
        const { actions } = this.state;

        actions.isLoadingEditions = true;

        this.setState({
            actions: actions
        });
    }

    endUpdate() {
        const { actions } = this.state;

        actions.isLoadingEditions = false;

        this.setState({
            actions: actions
        });
    }

    updateNetwork() {
        const { actions } = this.state;

        actions.active.isLoading = true;

        this.setState({
            actions: actions
        }, () => {
            const { edition } = this.context;

            this.getMapPoints(edition, "active");
            this.getStops(edition, "active", "activeStops", "isLoadingActiveStops");
        });
    }

    updateDraftNetwork() {
        const { actions } = this.state;

        actions.draft.isLoading = true;

        this.setState({
            actions: actions
        }, () => {
            const { edition } = this.context;

            this.getMapPoints(edition, "draft");
            this.getStops(edition, "draft", "draftStops", "isLoadingDraftStops");
        });
    }

    // ----------------------

    listSuccessCallback(result, dataType, updateData, updateAction, callback) {
        const { data, pagination, actions } = this.state;
        const totalPages = PaginationHelper.getTotalPages(result.length, pagination[dataType].elementsPerPage);

        actions[dataType][updateAction] = false;
        data[dataType][updateData] = result;
        if (0 !== totalPages) {
            pagination.page = pagination.page > totalPages ? totalPages : pagination.page;
        }
        else {
            pagination.page = 1;
        }

        // Update data
        this.setState({
            data: data,
            actions: actions,
            pagination: pagination,
        }, () => {
            if ("function" === typeof (callback)) {
                callback();
            }
        });
    }

    listErrorCallback(messageReceived, dataType, updateData, updateAction) {
        const { data, pagination, actions, message } = this.state;

        actions[dataType][updateAction] = false;
        data[dataType][updateData] = [];
        pagination[dataType].page = 1;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            data: data,
            actions: actions,
            pagination: pagination,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    listDependenciesSuccessCallback(result, updateData, updateAction, callback) {
        const { dependencies, actions } = this.state;

        actions[updateAction] = false;
        dependencies[updateData] = result;

        // Update data
        this.setState({
            dependencies: dependencies,
            actions: actions
        }, () => {
            if ("function" === typeof (callback)) {
                callback();
            }
        });
    }

    listDependenciesErrorCallback(messageReceived, updateData, updateAction) {
        const { dependencies, actions, message } = this.state;

        actions[updateAction] = false;
        dependencies[updateData] = [];

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            dependencies: dependencies,
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    operationSuccessCallback(result, updateAction, dataType, callback) {
        const { actions, message } = this.state;

        actions[dataType][updateAction] = false;

        if (message.show) {
            result.message = `${message.message}\n${result.message}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: result.message,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        if ("function" === typeof (callback)) {
            callback(result.data);
        }
    }

    operationErrorCallback(messageReceived, updateAction, dataType) {
        const { actions, message } = this.state;

        actions[dataType][updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // ----------------------

    getMapPoints(edition, dataType) {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;

        actions[dataType].isLoading = true;
        commands[dataType].mapPoints.getAll(
            edition,
            selectedProviderId,
            (a) => this.listSuccessCallback(a, dataType, "mapPoints", "isLoading"),
            (a) => this.listErrorCallback(a, dataType, "mapPoints", "isLoading")
        );

        this.setState({
            actions: actions
        });
    }

    getStops(edition, dataType, dependencie, updateAction) {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;

        actions[updateAction] = true;
        commands[dataType].stops.getWithoutMapPoint(
            edition,
            selectedProviderId,
            (a) => this.listDependenciesSuccessCallback(a, dependencie, updateAction),
            (a) => this.listDependenciesErrorCallback(a, dependencie, updateAction)
        );

        this.setState({
            actions: actions
        });
    }

    getInterfaces() {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;

        actions.isLoadingInterfaces = true;
        commands.interfaces.getAll(
            selectedProviderId,
            (a) => this.listDependenciesSuccessCallback(a, "interfaces", "isLoadingInterfaces"),
            (a) => this.listDependenciesErrorCallback(a, "interfaces", "isLoadingInterfaces")
        );

        this.setState({
            actions: actions
        });
    }

    // ----------------------

    onSearch(filter) {
        const { render } = this.state;

        render.filter = filter;

        this.setState({
            render: render
        });
    }

    onSelectTab(key) {
        const { render } = this.state;

        render.tab = key;

        this.setState({
            render: render
        });
    }

    onToggleIsComparing() {
        const { render } = this.state;

        render.compare = !render.compare;

        this.setState({
            render: render
        });
    }

    onChangePage(page, dataType) {
        const { pagination } = this.state;

        pagination[dataType].page = page;

        this.setState({
            pagination: pagination
        });
    }

    onChangeElementsPerPage(elementsPerPage, dataType) {
        const { pagination } = this.state;

        pagination[dataType].elementsPerPage = elementsPerPage;

        this.setState({
            pagination: pagination
        });
    }

    onChangeValue(e, value, dataType) {
        const { form } = this.state;

        form[dataType].mapPoint.obj[value] = e.target.value;

        this.setState({
            form: form,
        });
    }

    onSelectValue(e, value, dataType) {
        const { form, dependencies} = this.state;

        if("stops" !== value) {
            form[dataType].mapPoint.obj[value] = e;
        }

        if("active" === dataType && "stops" === value) {
            form[dataType].mapPoint.obj[value] = e;
            dependencies.activeStops = dependencies.activeStops.filter(stop => stop.id !== !e.includes(stop));
        }

        if("draft" === dataType && "stops" === value) {
            form[dataType].mapPoint.obj[value] = [...form[dataType].mapPoint.obj[value], dependencies.draftStops.find(stop => stop.id === e.value)];
            dependencies.draftStops = dependencies.draftStops.filter(stop => stop.id !== e.value);
        }

        this.setState({
            form: form,
            dependencies: dependencies
        });
    }

    onRemoveSelectValue(e, value, dataType) {
        const { form, dependencies } = this.state;

        if("active" === dataType) {
            dependencies.activeStops = [...dependencies.activeStops, ...form[dataType].mapPoint.obj[value].filter(existingElement => existingElement.id === e)];
        }

        if("draft" === dataType) {
            dependencies.draftStops = [...dependencies.draftStops, ...form[dataType].mapPoint.obj[value].filter(existingElement => existingElement.id === e)];
        }

        form[dataType].mapPoint.obj[value] = form[dataType].mapPoint.obj[value].filter(existingElement => existingElement.id !== e);

        this.setState({
            form: form,
            dependencies: dependencies
        });
    }

    onCalculateCoordinates(dataType) {
        const { form } = this.state;

        if(undefined === form[dataType].mapPoint.obj || !Array.isArray(form[dataType].mapPoint.obj.stops)) {
            return;
        }

        const coordinates = form[dataType].mapPoint.obj.stops.reduce((output, stop) => {
            output.latitude += stop.latitude;
            output.longitude += stop.longitude;

            return output;
        }, { latitude: 0, longitude: 0});

        form[dataType].mapPoint.obj.latitude = coordinates.latitude / form[dataType].mapPoint.obj.stops.length;
        form[dataType].mapPoint.obj.longitude = coordinates.longitude / form[dataType].mapPoint.obj.stops.length;

        this.setState({
            form: form
        });
    }

    onCreateClick(dataType) {
        const { form } = this.state;

        form[dataType].mapPoint = {
            title: "Criar",
            type: "create",
            original: undefined,
            obj: {
                id: 0,
                name: "",
                latitude: "",
                longitude: "",
                addInfo: "",
                stops: []
            },
            nameInputError: null,
            latitudeInputError: null,
            longitudeInputError: null
        };

        this.setState({
            form: form
        });
    }

    onEditClick(mapPoint, dataType) {
        const { form, render } = this.state;

        if (render.compare) {
            const { data } = this.state;

            mapPoint = data[dataType].mapPoints.find(unmuted => unmuted.id === mapPoint.id);
        }

        form[dataType].mapPoint = {
            title: "Editar",
            type: "edit",
            original: mapPoint,
            obj: Object.assign({
                id: 0,
                name: "",
                latitude: "",
                longitude: "",
                addInfo: "",
                stops: []
            }, mapPoint),
            nameInputError: null,
            latitudeInputError: null,
            longitudeInputError: null
        };

        this.setState({
            form: form
        });
    }

    onMapPointFormExit(dataType) {
        const { form } = this.state;

        form[dataType].mapPoint = undefined;

        this.setState({
            form: form
        });
    }

    onDeleteClick(mapPoint, dataType) {
        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar o ponto notável "${mapPoint.name}"`,
                style: "warning",
                icon: "alert",
                argument: {
                    operation: "delete",
                    id: mapPoint.id,
                    dataType: dataType
                }
            }
        });
    }

    onSave(dataType) {
        if (this.isValidInput(dataType)) {
            const { edition } = this.context;
            const { form, commands, actions } = this.state;

            actions[dataType].isUpdating = true;

            const callback = () => this.getMapPoints(edition, dataType);
            commands[dataType].mapPoints.save(
                edition,
                form[dataType].mapPoint.obj,
                (a) => this.operationSuccessCallback(a, "isUpdating", dataType, callback),
                (a) => this.operationErrorCallback(a, "isUpdating", dataType)
            );

            this.setState({
                actions: actions
            });

            this.onMapPointFormExit(dataType);
        }
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { actions } = this.state;

        if (isToExecute) {
            const { edition } = this.context;
            const { commands } = this.state;

            switch (argument.operation) {
                case "delete":
                    actions[argument.dataType].isDeleting = true;
                    commands[argument.dataType].mapPoints.delete(
                        edition,
                        argument.id,
                        (a) => this.operationSuccessCallback(a, "isDeleting", argument.dataType, () => this.getMapPoints(edition, argument.dataType)),
                        (a) => this.operationErrorCallback(a, "isDeleting", argument.dataType)
                    );
                    break;

                default: // DO NOTHING
                    break;
            }
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    // ----------------------

    isValidInput(dataType) {
        const { form } = this.state;
        let errors = 0;

        form[dataType].mapPoint.nameInputError = null;
        form[dataType].mapPoint.latitudeInputError = null;
        form[dataType].mapPoint.longitudeInputError = null;

        if (undefined === form[dataType].mapPoint.obj.name || null === form[dataType].mapPoint.obj.name || "" === form[dataType].mapPoint.obj.name) {
            form[dataType].mapPoint.nameInputError = 'error';
            errors++;
        }

        if (undefined === form[dataType].mapPoint.obj.latitude || null === form[dataType].mapPoint.obj.latitude || "" === form[dataType].mapPoint.obj.latitude) {
            form[dataType].mapPoint.latitudeInputError = 'error';
            errors++;
        }

        if (undefined === form[dataType].mapPoint.obj.longitude || null === form[dataType].mapPoint.obj.longitude || "" === form[dataType].mapPoint.obj.longitude) {
            form[dataType].mapPoint.longitudeInputError = 'error';
            errors++;
        }

        this.setState({
            form: form
        });

        return 0 === errors;
    }

    // ----------------------

    renderActiveForm() {
        const { form } = this.state;

        if (undefined === form.active.mapPoint) {
            return null;
        }

        const { dependencies } = this.state;

        return (
            <MapPointActiveForm show={true}
                form={form.active.mapPoint}
                stops={dependencies.activeStops}
                interfaces={dependencies.interfaces}
                onChangeValue={(a, b) => this.onChangeValue(a, b, "active")}
                onSelectValue={(a, b) => this.onSelectValue(a, b, "active")}
                onRemoveSelectValue={(a, b) => this.onRemoveSelectValue(a, b, "active")}
                onCalculateCoordinates={() => this.onCalculateCoordinates("active")}
                onSave={() => this.onSave("active")}
                onHide={() => this.onMapPointFormExit("active")} />
        );
    }

    renderDraftForm() {
        const { form } = this.state;

        if (undefined === form.draft.mapPoint) {
            return null;
        }

        const { dependencies } = this.state;

        return (
            <MapPointDraftForm show={true}
                form={form.draft.mapPoint}
                stops={dependencies.draftStops}
                interfaces={dependencies.interfaces}
                onChangeValue={(a, b) => this.onChangeValue(a, b, "draft")}
                onSelectValue={(a, b) => this.onSelectValue(a, b, "draft")}
                onRemoveSelectValue={(a, b) => this.onRemoveSelectValue(a, b, "draft")}
                onCalculateCoordinates={() => this.onCalculateCoordinates("draft")}
                onSave={() => this.onSave("draft")}
                onHide={() => this.onMapPointFormExit("draft")} />
        );
    }

    renderMapPointsActive() {
        const { data, actions, render, pagination } = this.state;

        return (
            <MapPointsActive mapPoints={data.active.mapPoints}
                draftMapPoints={data.draft.mapPoints}
                currentPage={pagination.active.page}
                elementsPerPage={pagination.active.elementsPerPage}
                isLoading={actions.active.isLoading || (render.isComparing && actions.draft.isLoading)}
                filter={render.filter}
                isComparing={render.compare}
                onChangePage={(a) => this.onChangePage(a, "active")}
                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a, "active")}
                onEditClick={(a) => this.onEditClick(a, "active")}
                onDeleteClick={(a) => this.onDeleteClick(a, "active")} />
        );
    }

    renderMapPointsDraft() {
        const { data, actions, pagination, render } = this.state;

        if (actions.draft.isLoading) {
            return (<LoadingSpinner />)
        }

        return (
            <MapPointsDraft mapPoints={data.draft.mapPoints}
                currentPage={pagination.draft.page}
                elementsPerPage={pagination.draft.elementsPerPage}
                isLoading={actions.draft.isLoading}
                filter={render.filter}
                isComparing={render.compare}
                onChangePage={(a) => this.onChangePage(a, "draft")}
                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a, "draft")}
                onEditClick={(a) => this.onEditClick(a, "draft")}
                onDeleteClick={(a) => this.onDeleteClick(a, "draft")} />
        );
    }

    renderTabOptions(selectedTab) {
        if ("active" === selectedTab) {
            const { render } = this.state;

            return (
                <div className="tab-options">
                    <label>
                        <Toggle className="comparison-toggle"
                            checked={render.isComparing}
                            icons={false}
                            onChange={() => this.onToggleIsComparing()} />
                        <span>COMPARAR</span>
                    </label>
                </div>
            );
        }

        return null;
    }

    renderTabs() {
        const { render } = this.state;

        return (
            <div className="tab-with-options">
                <Tabs id="datamanger_tabs" activeKey={render.tab} onSelect={(a) => this.onSelectTab(a)}>
                    <Tab eventKey="active" key="active" title="Rede Ativa">
                        {this.renderMapPointsActive()}
                    </Tab>
                    <Tab eventKey="draft" key="draft" title="Rascunho">
                        {this.renderMapPointsDraft()}
                    </Tab>
                </Tabs>
                {this.renderTabOptions(render.tab)}
            </div>
        );
    }

    renderButtons(selectedTab) {
        if ("active" === selectedTab) {
            return (
                <ButtonToolbar className="pull-right title-row-col-btns">
                    <Button onClick={() => this.onCreateClick("active")}>CRIAR</Button>
                </ButtonToolbar>
            );
        }

        if ("draft" === selectedTab) {
            return (
                <ButtonToolbar className="pull-right title-row-col-btns">
                    <Button onClick={() => this.onCreateClick("draft")}>CRIAR</Button>
                </ButtonToolbar>
            );
        }

        return null;
    }

    renderOperationFeedback(text, isExecuting) {
        return (
            <HandleMessage
                title={text}
                message={<LoadingSpinner />}
                style={`primary`}
                icon="transfer"
                show={isExecuting}
                small
                noButtons />
        );
    }

    render() {
        const { actions, render, message, dialog } = this.state;

        return (
            <div>
                <EditionSelector />

                <TitleRow title="Pontos Notáveis" showSeparator={true}>
                    <Col className="padding-0" xs={2} sm={1} md={4}>
                        {this.renderButtons(render.tab)}
                    </Col>
                    <Col className="padding-0" xs={10} sm={11} md={8}>
                        <div className="search-bar">
                            <SearchBar onSearch={(a) => this.onSearch(a)} />
                        </div>
                    </Col>
                </TitleRow>

                <div className="margin-top-15">
                    {this.renderTabs()}
                </div>

                {this.renderActiveForm()}
                {this.renderDraftForm()}

                {
                    this.renderOperationFeedback(
                        "A Executar...",
                        actions.active.isUpdating || actions.active.isDeleting || actions.draft.isUpdating || actions.draft.isDeleting
                    )
                }
                {this.renderOperationFeedback("A Carregar Edição...", actions.isLoadingEditions)}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}
